import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { ErrorLogLevel, StructuredLogAttributes } from '../models/error-log';

/**
 * Where ErrorService's logs go: Sentry Logs. A service rather than a direct Sentry.logger call so
 * a spec can replace it (a webpack namespace import cannot be spied on). With Sentry disabled
 * there is no client and the call does nothing.
 */
@Injectable({
	providedIn: 'root'
})
export class SentryLogService {
	write(level: ErrorLogLevel, message: string, attributes: StructuredLogAttributes): void {
		Sentry.logger[level](message, attributes);
	}
}
